import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingController, MenuController, PopoverController, ToastController } from '@ionic/angular';
import { LoadingService } from 'src/app/services/loading.service';
import { ItemInOrderOutputDto, OrderOutputDto, OrderService } from 'src/generated_client';
import { PopoverOrderConfirmComponent } from '../popover-order-confirm/popover-order-confirm.component';
import { PopoverOrderRejectComponent } from '../popover-order-reject/popover-order-reject.component';

import { BLE } from '@ionic-native/ble/ngx';
import { printOrder } from 'src/app/helpers/print.helper';

interface BluetoothDevice {
  id: string;
  service: string;
  characteristic: string;
}

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss'],
})

export class OrderDetailComponent implements OnInit {

  routerId: string;
  order: OrderOutputDto = {};
  orderReady = false;
  hiddenButtons = true;
  notes: number;
  loadingCtrl: any;
  items: ItemInOrderOutputDto[] = [];
  selectConection = false;
  listConection = [];
  connectedTo: any = {};
  paymentMethod: string;
  isConnected: boolean;
  printQueue: any[] = [];
  hasPermissions = false;
  printCount = 2;
  isScanning = false;
  mtuSize = 512;

  device: BluetoothDevice;

  constructor(
    private menu: MenuController,
    private orderService: OrderService,
    private activateRoute: ActivatedRoute,
    private popoverController: PopoverController,
    private router: Router,
    private ngZone: NgZone,
    private ble: BLE,
    private loading: LoadingService,
    private toastController: ToastController,
    public loadingController: LoadingController,

  ) {
    this.menu.enable(true, 'custom');
  }

  async ngOnInit() {

    await this.loading.presentLoading();

    this.tryLoadConnection();

    this.routerId = this.activateRoute.snapshot.paramMap.get('id');

    this.askPermissions();

    this.getOrder();
  }

  public async orderConfirm(order: OrderOutputDto) {

    await this.loading.presentLoading();

    const popover = await this.popoverController.create({
      component: PopoverOrderConfirmComponent,
      componentProps: {
        order
      },
      translucent: true,
      animated: true,
      cssClass: 'my-custom-class',
    });

    await popover.present().then(async () => {
      await this.loading.dismiss();
    });

    await popover.onDidDismiss().then(async (response: any) => {

      if (response.data && response.data.optionSelected) {
        await this.aceptOrder(order, response);
      }
    });
  }

  public async orderReject(order: OrderOutputDto) {

    const popover = await this.popoverController.create({
      component: PopoverOrderRejectComponent,
      componentProps: {
        order
      },
      translucent: true,
      animated: true,
      cssClass: 'my-custom-class',
    });

    popover.onDidDismiss();

    return await popover.present();
  }

  public async finishOrder(cdOrder: number) {

    await this.loading.presentLoading();

    await this.orderService.apiOrderConfirmDeliverPut(cdOrder).toPromise().catch(
      err => {

        console.log(err);

        if (err.error.error)
          this.presentToast(err.error.error);
        else
          this.presentToast("Ocurrieron errores intente mas tarde");

        this.loading.dismiss();
      }
    );

    await this.loading.dismiss()
      .then(async () => {
        await this.router.navigate(['/orders-summary']);
      });
  }

  public async onTheWay(cdOrder: number) {

    await this.loading.presentLoading();

    this.orderService.apiOrderOnTheWayPut(cdOrder).subscribe(x => {

      this.loading.dismiss();

      if (x)
        this.router.navigateByUrl('/orders-summary');

    }, err => {
      console.log(err);

      if (err.error.error)
        this.presentToast(err.error.error)
      else
        this.presentToast("Ocurrieron errores, intente mas tarde");

      this.loading.dismiss();
    });
  }

  public async goTo(ruta: string) {
    await this.router.navigateByUrl(ruta);
  }

  public getTotal(): number {

    let total: number = this.order.qtTotal;

    if (this.order.qtDiscount)
      total -= this.order.qtDiscount;

    if (this.order.qtDCharges)
      total += this.order.qtDCharges;

    return total;
  }

  private async presentToast(message: string) {
    const toast = await this.toastController.create({
      message,
      duration: 2000
    });
    toast.present();
  }

  private async aceptOrder(order: OrderOutputDto, response: any) {

    await this.loading.presentLoading();

    await this.orderService.apiOrderConfirmOrderPut(order.cdOrder, response.data.optionSelected)
      .toPromise()
      .then(async (response) => {

        if (response) {
          await this.getOrder();
          await this.loading.dismiss();
          this.listPairedDevices();
        }
      })
      .catch(error => {

        let errorMsj = error.error.error;

        if (errorMsj)
          this.presentToast(errorMsj);

        else
          this.presentToast("Ocurrieron errores, intente mas tarde");

        this.loading.dismiss();
      });
  }

  private async getOrder() {

    await this.orderService.apiOrderGetOneGet(parseInt(this.routerId)).toPromise()
      .then(async x => {

        this.order = x;

        this.notes = this.order.dsNotes ? this.order.dsNotes.length : 0;

        this.items = this.order.itemInOrderOutputDtos;

        this.paymentMethod = this.order.nmPaymentMethod == 0 ? 'Efectivo' : 'Tarjeta';

        this.orderReady = this.order.nmStatus == 0 ? false : true;

        this.hiddenButtons = false;

        this.loading.dismiss();
      }).catch(async err => {

        console.log(err);

        await this.loading.dismiss();
      });
  }


  // Print order, try to connects if not connected and push print to queue,
  async printOrder() {

    this.closeConectionPopup();

    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Imprimiendo ticket.',
    });

    await loading.present();

    const resultByte = printOrder(this.order, this.paymentMethod);
    for (let i = 0; i < this.printCount; i++) {
      this.printQueue.push(resultByte);
    }
    try {
      await this.print();
    } catch (e) {
      console.log(e);
    }
    await loading.dismiss();
  }

  closeConectionPopup() {
    this.selectConection = false;
    //this.listConection = [];
  }

  deviceDisconnected() {
    // this.BluetoothSerial.disconnect();
  }

  // Connects to device and call onConnect callback
  connect(device) {
    return new Promise((resolve, reject) => {
      this.ble.connect(device.id).subscribe(async (res) => {
        this.findCharacteristics(device.id, res);
        await this.onConnect(device);
        resolve(true);
      }, (err) => {
        reject(err);
      });
    });
  }

  findCharacteristics(id, data) {

    const { characteristics } = data;

    const [c] = characteristics.filter(x => x.properties.some(y => y.match(/^(Write)$/)));

    if (c) {
      const { characteristic, service } = c;
      this.device = { id, service, characteristic };
      this.saveConnection({ id, service, characteristic });
    } else {
      throw new Error('Error obtaining device characteristic and service');
    }
  }

  saveConnection(data) {
    localStorage.setItem('bluetooth-data', JSON.stringify(data));
  }

  tryLoadConnection() {
    const data = localStorage.getItem('bluetooth-data');

    if (data) {
      const { id, service, characteristic } = JSON.parse(data);

      this.device = { id, service, characteristic };

      this.ble.autoConnect(id, this.onConnect.bind(this), this.onDisconnect.bind(this));
    }
  }
  async onConnect(data) {

    this.ble.requestMtu(data.id, 512).then((mtuSize) => {
      this.mtuSize = mtuSize;
    }, (err) => {
      console.log('MTU Rejected', err);
    });

    this.ngZone.run(() => {

      this.isConnected = true;
      this.connectedTo = data;

      if (!this.listConection.find(x => x.id === data.id)) {
        this.listConection.push(data);
      }
    });

    await this.print();
  }

  async print() {

    if (this.printQueue.length > 0) {

      for (const q of this.printQueue) {

        const buffer = q.buffer;

        const chunkSize = this.mtuSize;

        for (let s = 0; s < buffer.byteLength; s += chunkSize) {

          const chunk = buffer.slice(s, s + chunkSize);

          await this.ble.write(this.device.id, this.device.service, this.device.characteristic, chunk);
        }
      }

      this.printQueue = [];
    }
  }

  onDisconnect(data) {

    console.log(data);

    this.ngZone.run(() => {
      this.isConnected = false;
      this.connectedTo = {};
    });
  }

  listPairedDevices() {

    this.selectConection = true;
    this.isScanning = true;

    setTimeout(() => {
      this.ngZone.run(() => {
        this.isScanning = false;
      });
    }, 10000);

    this.ble.scan([], 10).subscribe(res => {

      console.log('device ', res);

      if (res && res.name) {

        if (this.listConection.find(x => x.id === res.id))
          return;

        this.ngZone.run(() => {
          this.listConection.push(res);
        });
      }
    }, err => {

      console.log(err);

      this.ngZone.run(() => {
        this.isScanning = false;
      });
    });
  }

  /*
  doPrint() {
      if (!this.isConnected) {
          this.listPairedDevices();
      } else {
          this.printOrder(this.device);
      }
  }
  */

  async askPermissions() {

    try {
      await this.ble.isEnabled();
    }
    catch (e) {
      await this.ble.enable();
    }

    this.ble.scan([], 1)
      .toPromise()
      .then(() => {
        this.hasPermissions = true;
      })
      .catch(() => {
        this.hasPermissions = false;
      });
  }

  connectTo(e) {

    const device = this.listConection.find(x => x.id === e.detail.value);

    if (device) {
      this.connect(device);
    }
  }
}
